














import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import ChannelApi from "../../repository/ChannelApi";
import {TopicApi} from "../../repository/TopicApi";
import {PostsApi} from "../../repository/PostsApi";
import * as postRecord from "@/store/Posts/PostRecord";
@Component({
    components: {


    },
    name: 'DeletePostModal',
})
export default class DeletePostModal extends Vue{
    @Prop({ default: false })showDialog!:boolean
    @Prop({ default: '' })postId!:string
    postApi: PostsApi = new PostsApi()
    closeModal(){
        this.$emit('cancelModal')
    }
    async deletePost(){


        let response = await this.postApi.deletePost(this.postId)
        if (response.status == 204){
            postRecord.deletePostById(this.$store, this.postId)
        }
        this.$emit('onPostDeleted')
    }
}
